module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_27.9cc572b8.jpg";